import React, { PureComponent } from 'react';
import 'eventsource-polyfill';
import { getUser } from '../../services/auth';
import '../../css/tvCSS/style.css';
import api from '../../services/api';
import sound from './call_sound.mp3';
import webstomp from 'webstomp-client';
import SockJS from 'sockjs-client';

webstomp.debug = null;

export default class Painel extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      senhaAtual: {
        local: '',
        atendente: '',
        cliente: '',
      },
      senhasAnteriores: [],
      dataAtual: '',
      anoAtual: '',
      horaAtual: '',
      webSocketConnected: false,
      client: null,
      somAtivo: false,
    };

    this._connecting = false;
  }

  atualizarDataHora = () => {
    const dataAtual = new Date();
    const dataFormatada = dataAtual.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
    });
    const anoFormatado = dataAtual.getFullYear();
    const horaFormatada = dataAtual.toLocaleTimeString();
    this.setState({
      dataAtual: dataFormatada,
      anoAtual: anoFormatado,
      horaAtual: horaFormatada,
    });
  };



  connectAndReconnect = () => {
    const estabelecimento = getUser().estabelecimento;
    const cnpj = estabelecimento.cpfCnpj;

    if (this._connecting) return;

    this._connecting = true;

    const doConnect = () => {
      const sock = new SockJS(window.IP_SERVER_WS);
      if (window.location.hostname === "localhost") {
        window._sock = sock;
      }
      const client = webstomp.over(sock);
      if (window.location.hostname === "localhost") {
        window._client = client;
      }
      this.setState({ client });

      client.connect(
        {},
        () => {
          this._connecting = false;
          this.setState({ webSocketConnected: true });
          client.subscribe('/topic/senhas/' + cnpj, this.handleDataUpdate);
        },
        (error) => {
          this._connecting = false;
          this.setState({ webSocketConnected: false, client: null });
          setTimeout(doConnect, 5000);
        }
      );

      sock.onclose = () => {
        this._connecting = false;
        this.setState({ webSocketConnected: false, client: null });
        setTimeout(doConnect, 5000);
      };
    };

    doConnect();
  };

  ativarSom = () => {
    if (!this.audioRef) return;
    try {
      this.audioRef.muted = false;
      this.audioRef.volume = 1.0;
      this.audioRef.play().catch(() => { });
    } catch (e) { }

    this.setState({ somAtivo: true });
  };

  playSound = () => {
    if (!this.state.somAtivo) return;
    if (!this.audioRef) return;
    try {
      this.audioRef.pause();
      this.audioRef.currentTime = 0;

      const p = this.audioRef.play();
      if (p && p.catch) p.catch(() => { });
    } catch (e) {
      console.log('Erro ao tocar áudio', e);
    }
  };


  handleDataUpdate = (messageOutput) => {
    let senha = JSON.parse(messageOutput.body);
    this.updateSenhas(senha);
  };

  updateSenhas = (senha) => {
    this.playSound();

    this.setState((prev) => {
      const senhasAnteriores = [this.state.senhaAtual, ...prev.senhasAnteriores].slice(0, 3);

      return {
        senhaAtual: senha,
        senhasAnteriores,
      };
    });
  };

  getSenhas = () => {
    api.get('/senha/all').then(
      (r) => {
        if (r.data && r.data.length > 0) {
          const senhasAnteriores = r.data.slice(1, 4);
          this.setState({
            senhaAtual: r.data[0],
            senhasAnteriores,
          });
        }
      },
      (erro) => {
        console.log('erro do senha All');
        console.log(erro);
      }
    );
  };

  componentDidMount() {
    this.connectAndReconnect();
    this.getSenhas();
    this.atualizarDataHora();
    this.intervalo = setInterval(this.atualizarDataHora, 1000);
  }

  render() {
    const estabelecimento = getUser().estabelecimento;
    return (
      <>
        <audio id="audio" ref={(ref) => (this.audioRef = ref)}>
          <source src={sound} type="audio/mpeg" />
          <source src="./call_sound.ogg" type="audio/ogg; codecs=vorbis" />
        </audio>
        {!this.state.somAtivo && (
          <button
            onClick={this.ativarSom}
            style={{
              position: 'absolute',
              top: 7,
              left: 7,
              padding: '5px 7px 5px 7px',
              fontSize: 12,
              zIndex: 9999,
              borderRadius: 10,
              background: 'rgb(234 240 244)',
              color: '#000',
              cursor: 'pointer',
              border: '1px solid',

            }}
          >
            Ativar Som
          </button>
        )}

        <div className="top d-flex justify-content-between align-items-center">
          <div>
            <h2 id="dataAtual">{this.state.dataAtual}</h2>
            <h2 className="year" id="anoAtual">{this.state.anoAtual}</h2>
          </div>
          <h1 id="nomeEstabelecimento">{estabelecimento.nome}</h1>
          <h2 id="horaAtual">{this.state.horaAtual}</h2>
        </div>

        <div className="ON callAnimate" id="painelAnimado">
          {this.state.senhaAtual && (
            <div className="chamada d-flex flex-column align-items-center justify-content-center" id="current">
              <div className="txtPaciente" id="currentPaciente">{this.state.senhaAtual.cliente}</div>

              {this.state.senhaAtual.prefixFila && (
                <div className="txtSenha" id="currentSenha">
                  Senha: {this.state.senhaAtual.prefixFila + '-' + this.state.senhaAtual.number}
                </div>
              )}

              <div className="txtSala" id="currentLocal">{this.state.senhaAtual.local}</div>
              <div className="txtProfissional" id="currentProfissional">
                <i>{this.state.senhaAtual.atendente}</i>
              </div>
            </div>
          )}

          <div className="atendimentosAnteriores d-flex justify-content-center row" id="atendimentosAteriores">
            {this.state.senhasAnteriores.map((senha, index) => (
              <div key={index} className="itemAnterior col">
                <div className="txtPaciente">{senha.cliente}</div>
                <div className="txtSala">{senha.local}</div>
              </div>
            ))}
          </div>
        </div>
      </>
    );
  }
}
